module.exports = __webpack_public_path__ + "static/media/15.ae244e5d.jpg";